
import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import CustomTagMixin from '@/@next/mixins/CustomTag'
import TextToSpeechMixin from '@/@next/mixins/TextToSpeech'
import { messages } from '@/@next/i18n'
import { Html } from '@/@types/graphql'
import * as SETTINGS from '@/@next/store/settings2/types'

const config = {
  i18n: { messages },
  name: 'c-content-text'
}

@Component(config)
export default class Text extends Mixins(CustomTagMixin, TextToSpeechMixin) {

  @Prop({ type: String, required: false }) id!: string
  @Prop({ type: Object, required: true }) data!: Html
  @Prop({ type: Array, required: false }) people!: any[]
  @Prop({ type: Object, required: false }) options!: any
  // @Prop({ type: String, required: false }) ttsStatus!: string =

  @Getter(SETTINGS.GET_FEATURES)
  _settingsFeatures!: any

  collapsed: boolean = false
  defaultLineClamp: number = 3
  lineClamp: number = this.defaultLineClamp
  maxLineClamp: number = 30
  // isCurrentUtterance: boolean = false
  // currentUtteranceisPlaying: boolean = false
  
  get html () {
    return this.data.html
  }

  get text () {
    return this.data.text
  }

  // get allowTts () {
  //   return this._settingsFeatures?.includes('textToSpeech') && ('speechSynthesis' in window)
  // }

  get classes () {
    return {
      'collapsed': this.collapsed
      // 'is-playing': this.isCurrentUtterance && this.currentUtteranceisPlaying
    }
  }

  get htmlWithoutPTags () {
    return this.html.replace(/<p>/g, '<span>').replace(/<\/p>/g, '</span>')
  }

  get styles () {
    return { '-webkit-line-clamp': this.lineClamp } 
  }

  toggleCollapsed () {
    this.collapsed = !this.collapsed
  }

  setLineClamp (lineClamp: number) {
    this.lineClamp = lineClamp > 20 ? 20 : lineClamp < 1 ? 1 : lineClamp
  }

  checkCollaps () {
    if (!this.options?.collapse) return
    this.collapsed = this.options.collapse.collapsedOnStartup
    const lineClamp = this.options?.collapse?.lineClamp || this.defaultLineClamp
    if (!lineClamp.toString().includes('%')) return this.setLineClamp(lineClamp)
    const textElement = document.getElementById(`text-${this.id}`)
    if (!textElement) return this.setLineClamp(this.defaultLineClamp)
    const lineHeight = document?.defaultView?.getComputedStyle(textElement, null).getPropertyValue('line-height');
    if (!lineHeight) return this.setLineClamp(this.defaultLineClamp)
    const lineClampPercent = Math.round(
      ( parseInt(lineClamp, 10) *  window.innerHeight ) /
      ( 100 * parseInt(lineHeight, 10) ) )
    if (!lineClampPercent) return this.setLineClamp(this.defaultLineClamp)
    this.setLineClamp(lineClampPercent)
  }

  // toggleTtsOnCurrentUtterance () {
  //   if (!window.speechSynthesis.speaking || !this.isCurrentUtterance) {
  //     window.speechSynthesis.cancel()
  //     const speechSynthesis = new SpeechSynthesisUtterance()
  //     speechSynthesis.lang = this.$i18n.locale
  //     speechSynthesis.volume = 1
  //     speechSynthesis.rate = 1
  //     speechSynthesis.pitch = 1
  //     speechSynthesis.text = this.text || ''
  //     window.speechSynthesis.speak(speechSynthesis)
  //     speechSynthesis.onstart = () => {
  //       this.currentUtteranceisPlaying = true
  //       this.isCurrentUtterance = true
  //     };
  //     speechSynthesis.onend = () => {
  //       this.isCurrentUtterance = false
  //       this.currentUtteranceisPlaying = false
  //     };
  //     speechSynthesis.onerror = () => {
  //       window.speechSynthesis.cancel()
  //       this.isCurrentUtterance = false
  //       this.currentUtteranceisPlaying = false
  //     }
  //     speechSynthesis.onpause = () => {
  //       this.currentUtteranceisPlaying = false
  //     }
  //     speechSynthesis.onresume = () => {
  //       this.currentUtteranceisPlaying = true
  //     }
  //     // speechSynthesis.onboundary = (event) => {
  //     //   console.log('onboundary ', event, text);
  //     // }
  //   } else if (this.currentUtteranceisPlaying) {
  //     window.speechSynthesis.pause()
  //     this.currentUtteranceisPlaying = false
  //     // Check if the current tts is realy paused. else cancel the current tts
  //     setTimeout(() => { if (!window.speechSynthesis.paused) window.speechSynthesis.cancel() }, 500)
  //   } else {
  //     window.speechSynthesis.resume()
  //     this.currentUtteranceisPlaying = true
  //     // Check if the current tts is not realy paused. else cancel the current tts
  //     setTimeout(() => { if (window.speechSynthesis.paused) window.speechSynthesis.cancel() }, 500)
  //   }
  // }

  clickOnText () {
    this.collapsed = false
    // if (this.allowTts) this.clickOnTtsItem(this.text)
  }

  addToTTS () {
    this.addTtsItem({
      element: document.getElementById(`text-${this.id}`),
      text: this.text,
      locale: this.$i18n.locale
    })
  }

  mounted () {
    this.checkCollaps()
    // this.addToTTS()
  }

  activated () {
    this.checkCollaps()
  }

}
